import axios from "axios";
import { APIURL } from "./../Constantes";
import { getCabecera } from "../utils/getCabecera";
import { getError } from "../utils/errors";

const urlRole = "Role";
export const asignRole = async ({payload}) =>{
    return axios.post(`${APIURL}/${urlRole}/permit`, payload, 
    {
        headers: getCabecera()
    }).then((Response) =>{
        return Response.data;
    }).catch((Error) =>{
        return getError(Error);
    })
}
export const newRole = async ({payload}) =>{
    return axios.post(`${APIURL}/${urlRole}/create`, payload, 
    {
        headers: getCabecera()
    }).then((Response) =>{
        return Response.data;
    }).catch((Error) =>{
        return getError(Error);
    })
}
export const updateRole = async ({idRole, payload}) =>{
    return axios.put(`${APIURL}/${urlRole}/update/${idRole}`, payload, 
    {
        headers: getCabecera()
    }).then((Response) =>{
        return Response.data;
    }).catch((Error) =>{
        return getError(Error);
    })
}
export const getRoleAll = async () =>{
    return axios.get(`${APIURL}/${urlRole}/find`, 
    {
        headers: getCabecera()
    }).then((Response) =>{
        return Response.data;
    }).catch((Error) =>{
        //return Error.response.data;
        return [];
    })
}
export const getRoleID = async ({idRole}) =>{
    return axios.get(`${APIURL}/${urlRole}/${idRole}`, 
    {
        headers: getCabecera()
    }).then((Response) =>{
        return Response.data;
    }).catch((Error) =>{
        //return Error.response.data;
        return {};
    })
}
